module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<tr v-bind:id='rowId'>\n  <td>{{row.agreement_number}}</td>\n  <td>{{row.employee_name}}</td>\n  <td>{{row.position}}</td>\n  <td>{{row.salary}}</td>\n  <td>{{row.intensity}}</td>\n  <td>{{row.start_date}}</td>\n  <td>{{row.end_date}}</td>\n  <td>\n    <div class='form-group'>\n      <textarea class='form-control' cols='" + ($e($c(30))) + "' name='client_notes' v-model='row.client_notes'></textarea>\n    </div>\n  </td>\n</tr>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
